import { useMediaQuery } from '../hooks/useMediaQuery'

/**
 * En viewport móvil (<1024px) usa MobileComponent si existe;
 * si no, renderiza DesktopComponent (el shell MobileLayout lo envuelve desde GlobalLayout).
 * En desktop usa siempre DesktopComponent.
 */
export default function PageWrapper({
  MobileComponent,
  DesktopComponent,
  useMobileForAllRoles = false, // legacy no-op: mobile es por viewport para todos
  ...props
}) {
  const isMobileViewport = useMediaQuery('(max-width: 1023px)')

  if (isMobileViewport && MobileComponent) {
    return <MobileComponent {...props} />
  }

  return <DesktopComponent {...props} />
}
